var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetodologyPotentialGrowRussia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.4788 49.7496C81.4788 67.6306 66.9832 82.1262 49.1023 82.1262C34.1188 82.1262 21.512 71.9487 17.8203 58.1282H38.4506L49.1257 47.455H66.0271L78.1149 35.3672C80.2691 39.6989 81.4788 44.5828 81.4788 49.7496Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9865 66.5527V79.782C34.1553 78.6386 31.5211 77.1069 29.1543 75.2513V66.5527H36.9865Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0177 61.8809V81.8926C51.7963 82.0311 50.5553 82.1267 49.2968 82.1267C47.9036 82.1267 46.5319 82.0623 45.1855 81.8926V61.8809H53.0177Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.049 55.0879V75.2518C66.6822 77.1074 64.048 78.6391 61.2168 79.7825V55.0879H69.049Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7777 60.2827C89.3474 58.1285 91.0313 56.4505 93.1933 55.9178L97.1016 54.9559V44.5441L93.1952 43.5822C91.0274 43.0495 89.3455 41.3637 88.7757 39.2076C88.7679 39.1841 88.762 39.1607 88.7562 39.1373C88.1806 36.9832 88.7991 34.6866 90.4128 33.1451L93.322 30.3666L88.1377 21.3363L84.2586 22.4524C82.1181 23.0671 79.8235 22.4466 78.2547 20.8661C78.2099 20.8193 78.165 20.7744 78.1181 20.7276C76.5435 19.1529 75.9328 16.8544 76.5572 14.7159L77.6889 10.8427L68.684 5.61732L65.8918 8.51488C64.3464 10.1168 62.0518 10.7295 59.9035 10.1461C59.8138 10.1227 59.724 10.0973 59.6342 10.0739C57.4801 9.50415 55.802 7.82024 55.2694 5.65829L54.3074 1.75H43.8957L42.9338 5.65634C42.4011 7.82415 40.7152 9.5061 38.5591 10.0759C38.5357 10.0837 38.5123 10.0895 38.4889 10.0954C36.3347 10.671 34.0381 10.0524 32.4967 8.43878L29.7181 5.52951L20.6879 10.7139L21.804 14.5929C22.4186 16.7334 21.7981 19.028 20.2177 20.5968C20.1708 20.6417 20.126 20.6866 20.0791 20.7334C18.5045 22.308 16.206 22.9188 14.0674 22.2944L10.1942 21.1627L4.96888 30.1676L7.86644 32.9598C9.46839 34.5051 10.0811 36.7998 9.49766 38.948C9.47424 39.0378 9.44888 39.1276 9.42546 39.2173C8.85571 41.3715 7.17181 43.0495 5.00986 43.5822L1.10156 44.5441V54.9559L5.0079 55.9178C7.17571 56.4505 8.85766 58.1363 9.42937 60.2924C9.43522 60.3159 9.44107 60.3393 9.44693 60.3627C10.0225 62.5168 9.404 64.8134 7.79034 66.3549L4.88107 69.1334L10.0655 78.1637L13.9445 77.0476C16.085 76.4329 18.3796 77.0534 19.9484 78.6339C19.9933 78.6807 20.0381 78.7256 20.085 78.7724C21.6596 80.3471 22.2703 82.6456 21.646 84.7841L20.5142 88.6573L29.5191 93.8827L32.3113 90.9851C33.8567 89.3832 36.1513 88.7705 38.2996 89.3539C38.3894 89.3773 38.4791 89.4027 38.5689 89.4261C40.723 89.9958 42.4011 91.6798 42.9338 93.8417L43.8957 97.75H54.3074L55.2694 93.8437C55.802 91.6759 57.4879 89.9939 59.644 89.4241C59.6674 89.4163 59.6908 89.4105 59.7142 89.4046C61.8684 88.829 64.165 89.4476 65.7064 91.0612L68.485 93.9705L77.5152 88.7861L76.3991 84.9071C75.7845 82.7666 76.405 80.4719 77.9855 78.9032C78.0323 78.8583 78.0772 78.8134 78.124 78.7666C79.6986 77.1919 81.9972 76.5812 84.1357 77.2056L88.0089 78.3373L93.2342 69.3324L90.3367 66.5402C88.7347 64.9949 88.122 62.7002 88.7055 60.5519C88.7289 60.4622 88.7542 60.3724 88.7777 60.2827Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6563 26.4169C20.5334 32.3077 16.7246 40.5828 16.7246 49.7496C16.7246 67.6306 31.2202 82.1262 49.1012 82.1262C66.9822 82.1262 81.4778 67.6306 81.4778 49.7496C81.4778 31.8687 66.9822 17.373 49.1012 17.373C46.4788 17.373 43.9305 17.6872 41.4895 18.2745",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9375 28.6387L53.3179 36.2582H45.3706L35.1287 46.5001H26.8848",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4238 28.6836H60.9848V35.829",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.7012,
    cy: 21.2637,
    r: 1.95122,
    fill: "#11A0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodologyPotentialGrowRussia);
export default __webpack_public_path__ + "static/media/metodology-potential-grow-russia.7073bfd2db4098a309bc165c72fc3092.svg";
export { ForwardRef as ReactComponent };